import { PremiumMonthlyInfo } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

export const useFetchMonthlyPremiums = () => {
  const fetchMonthlyPremiums = async () => {
    const res = await medicareApiClient.premiumsApi.getPremiumsMonthly()
    return res.data
  }

  return useQuery<PremiumMonthlyInfo[] | undefined>(
    'monthlyPremiums',
    fetchMonthlyPremiums,
    {
      retry: false,
      refetchOnWindowFocus: false
    }
  )
}
